<template>
  <div id="announcement_list" class="announcement_list">
    <div class="listComps">
    <TableActionHeader 
      @filterChange="(val) => {this.filterString = val}"
      :selectOptions="statusOptions" 
      :selected="statusFilter" 
       @filterSelect="onFilterSelect"
      :selectOptions2="typeOptions" 
      :selected2="typeFilter" 
      @filterSelect2="onFilterSelect2"
      :selectOptions3="showSourceFilters ? sourceOptions : null"
      :selected3="sourceFilter" 
      @filterSelect3="onFilterSelect3"
      @newItem="this.onNewAnn">
    </TableActionHeader>
    <p class="force-row" style="width: 100%"> </p>
    <b-table hover striped :items="listData" :fields="fields"
        sticky-header="calc(100vh - 350px)"
        :responsive="false"
        :small="true"
        primary-key="tunnus"
        ref="announcementList"
        selectable
        select-mode="single"
        @row-selected="onRowSelected"
        :filter="filter"
        :filter-function="listFilterFunction"
        :per-page="pagingPerPage"
        @filtered="this.onFiltered"
        :current-page="this.currentPage"
        :busy="loading"
        class="infotext-table">
        <template v-slot:cell(status)="data">
          <InfoValidityIcon :info="data.item" scale="1.5" />
        </template>
        <template v-slot:cell(type)="data">
           <b-icon v-if="data.item.tyyppi == 1" icon="info-square" variant="dark" scale="1.5"/>
           <b-icon v-if="data.item.tyyppi == 5" icon="exclamation-triangle" variant="danger" scale="1.5"/>
        </template>
        <template v-if="$UiConfig('/data/announcements/showSource', true)" v-slot:cell(source)="data">
           <b-icon v-if="data.item.externalId" icon="link" variant="warning" scale="1.8" :title="getCreatedTooltip(data.item)"/>
           <b-icon v-else icon="person-fill" variant="dark" scale="1.5" :title="getCreatedTooltip(data.item)"/>
        </template>
        <template v-slot:cell(otsikko)="data">
           <div >{{ data.value }}</div>
        </template>
        <template v-slot:cell(teksti)="data">
            <span>{{ text(data.item) }}</span>
        </template>
        <template v-slot:cell(kelpoisuusalkaa)="data">
          <!--
            <p class="timeInTableCell"> &#8614; {{ alkuaika(data.item) }}</p>
            <p class="timeInTableCell"> &#8677; {{ loppuaika(data.item) }}</p>
          -->
            <p class="timeInTableCell"><b-icon icon="calendar-check" scale='1' variant='success'/>{{ alkuaika(data.item) }}</p>
            <p class="timeInTableCell"><b-icon icon="calendar-X" variant='danger'/>{{ loppuaika(data.item) }}</p>
        </template>
         <template #table-busy>
                <Loading />
          </template>
    </b-table>
    <TablePagination :perPage="pagingPerPage" :totalRows="listLength" @pageChange=onPageChange></TablePagination>
    </div>
  </div>
</template>

<script>
import announcements from '@/store/announcements/announcements'

import TablePagination from '@/components/Misc/TablePagination.vue'
import TableActionHeader from '@/components/Misc/TableActionHeader.vue'
import moment from "moment";

export default {
  name: 'TextAnnouncementList',
  components: {
    TableActionHeader,
    TablePagination
  },
  props: {
  },
  //event: 'announcementListChanged',
  data: function() {
    return {
      fields: [ 
        { key:'status', label: this.$t('text_announcement_list.validity'), sortable: true,  tdClass: 'status' },
        { key:'type', label: this.$t('text_announcement_list.type'), sortable: true, tdClass: 'type' },
        { key:'source', label: this.$t('info.source.label'), sortable: true, tdClass: 'type' },
        { key:'otsikko', label: this.$t('text_announcement_list.subject'), sortable: true, tdClass: 'name' },
        { key:"teksti", label:this.$t('text_announcement_list.text'), sortable: true },
        { key:"kelpoisuusalkaa", label:this.$t('text_announcement_list.validity_time'), sortable: true, tdClass: 'validity' },
      ],
      currentPage: 1,
      pagingPerPage: 10,
      selected: [],
      filterString: null,
      listData: [],
      loading: true,
      listLength: 0,
      statusOptions: [
        { id: 'all', label: this.$t("filter.no"), icon: 'filter',  caption: this.$t('text_announcement_list.status.valid') },
        { id: 'valid', label: this.$t('text_announcement_list.status.valid'), icon: 'check-circle', variant: 'success' },
        { id: 'upcoming', label: this.$t('text_announcement_list.status.upcoming'), icon: 'check-circle', variant: 'warning' },
        { id: 'expired', label: this.$t('text_announcement_list.status.expired'), icon: 'x-circle', variant: 'secondary' }
      ],
      typeOptions: [
        { id: 'ALL', label: this.$t("filter.no"), icon: 'filter', caption: this.$t("text_announcement_list.type") },
        { id: 1, label: this.$t('infotypeicon.text_info'), icon: 'info-square', variant: 'dark' },
        { id: 5, label: this.$t('infotypeicon.disruption'), icon: 'exclamation-triangle', variant: 'danger' },
      ],
      sourceOptions: [
        { id: 'all', label: this.$t("filter.no"), icon: 'filter', caption: this.$t("info.source.label") },
        { id: 'user', label: this.$t('info.source.user'), icon: 'person-fill', variant: 'dark' },
        { id: 'external', label: this.$t('info.source.external'), icon: 'link', variant: 'warning' },
      ],
      statusFilter: "valid",
      typeFilter: "ALL",
      sourceFilter: "all"

    }
  },
  computed: {
    storedTextAnnouncementList: function() {
      return this.$store.state.announcements.textAnnouncementList.listData;
    },
    filter() {
      return this.statusFilter + this.filterString;
    },
    showSourceFilters() {
     return this.$UiConfig('/ui/filters/sourceFiltersShown', false);
    },
  },
  beforeCreate: function() {
    if (!this.$store.state.announcements) {
      this.$store.registerModule("announcements" , announcements);
    }
  },
  mounted: function() {
    if(this.listData.length === 0) {
      this.loading = true;
      this.$store.dispatch('announcements/getTextAnnouncementList')
      .then(
          (/*data*/) => {/*this.listData = data;*/ this.loading = false;},
          () => { /* console.log("virhe tietojen haussa") */ }
        );
    }
    this.deselectAll();
  },
  watch: {
    storedTextAnnouncementList: function() {
      this.listData = this.storedTextAnnouncementList;
    }
  },
  methods: {
    listFilterFunction: function(item) {
      this.currentPage = 1;

      var statusFilterOK = this.statusFilter == "all" || this.getValidity(item) == this.statusFilter;

      var typeFilterOK = this.typeFilter == "ALL" || this.typeFilter == item.tyyppi;

      var sourceFilterOK = this.sourceFilter == "all" 
                        || this.sourceFilter == "user" && !item.externalId
                        || this.sourceFilter == "external" && item.externalId;


      if(this.filterString == null || this.filterString === "") {
         return statusFilterOK && typeFilterOK && sourceFilterOK;
      }
  

      // Tekstifiltteri
      if(statusFilterOK && typeFilterOK && sourceFilterOK) {
        try {
          if(this.filterString.length < 2) {
            return false;
          }
          var matchString = ".*"+this.filterString+".*";
          var regxi = new RegExp(matchString, 'i');
          if(regxi.test(item.otsikko)) {
            return true;
          } else {
            return false;
          }
        } catch(err) {
          return true;

        }
      } else {
        return false;
      }
    },
    onFiltered: function(filteredList) {
      this.listLength = filteredList.length;
    },
    onNewAnn: function() {
      this.$emit('newItem');
    },
    onPageChange: function(page) {
      this.currentPage = page;
    },
    getSelectedItem: function() {
        return this.selected;
    },
    dateFormatter: function(dateString) {
      var aika = moment(dateString);
      return aika.format("D.M.YYYY HH:mm")
    },
    onRowSelected: function(items) {
      this.selected = items
      this.$emit('selectedItem',this.selected);
    },
    deselectAll: function() {
      this.$refs.announcementList.clearSelected();
    },
    text: function(item) {
      var txt = "";
      for(var i = 0; i < 10; i++) {
        var key = new String(i);
        if(item.tiedoteTextList[key] && item.tiedoteTextList[key].length > 1) {
          txt = item.tiedoteTextList[key];
          //txt = txt.substr(0,100) + "..."
          break;
        }
      }
      return txt;
    },
    alkuaika: function(item) {
      // vanhan rakenteen mukainen kelpoisuusalkaa
      if(item.kelpoisuusalkaa && item.kelpoisuusalkaa != null) {
        var aika = moment(item.kelpoisuusalkaa);
        if(aika.isValid()) {
          return aika.format("D.M.YYYY")
        }
      }
      if(item.ajastusList[0].id == null) {
        return "";
      }

      var aikaisin = moment("20500101", "YYYYMMDD");
      item.ajastusList.forEach((i) => {
        var aika = moment(i.validityBegins, "YYYY-MM-DD")
        if(aika.isBefore(aikaisin)) {
          aikaisin = aika;
        }
      });
      return aikaisin.format("D.M.YYYY");
    },
    loppuaika: function(item) {
      /* Käsittämätön häkki
      Tällä tavoin filtteröidyn taulun pituus saadaan katsottua ekalla kerralla. myöhemmin se määritellään
      onFiltered metodin kautta joka olis oikea tapa tehdä se. se ei vaan toimi listan latauksessa */
      try{
        if(this.listLength == 0) {
          this.listLength = this.$refs.announcementList.filteredItems.length;
        }
      }catch(Error){/*tässä pitää olla täysin turha kommentti koska muuten tää paska ei käänny...*/}


      // vanhan rakenteen mukainen
      if(item.kelpoisuusloppuu != 'undefined' && item.kelpoisuusloppuu !== null) {
        var aika = moment(item.kelpoisuusloppuu);
        if(aika.isValid()) {
          return aika.format("D.M.YYYY")
        }
      }
      if(item.ajastusList[0].id == null) {
        return "";
      }
      
      var latest = moment("19700101", "YYYYMMDD");
      item.ajastusList.forEach((i) => {
        var aika = moment(i.validityEnds, "YYYY-MM-DD")
        if(aika.isAfter(latest)) {
          latest = aika;
        }
      });

      let formattedTime = latest.format("D.M.YYYY");
      if(formattedTime == "31.12.2099")
        formattedTime =  this.$t('announcement_schedule.valid_until_further_notice');
     
      return formattedTime;


    },
    isValid: function(item) {
      var nyt = moment();
      if(item.kelpoisuusloppuu && moment(item.kelpoisuusloppuu).isValid()) {
        var loppu = moment(item.kelpoisuusloppuu);
        var alku = moment(item.kelpoisuusalkaa);
        if(alku.isBefore(nyt) && loppu.isAfter(nyt)) {
          return true;
        } else false;
      } else {
        // Uuden aikataulurakenteen mukainen tiedote
        var validi = false;
        item.ajastusList.forEach((i) => {
            var loppu = moment(i.validityEnds, "YYYY-MM-DD");
            loppu.hour(23);
            loppu.minute(59);
            var alku = moment(i.validityBegins, "YYYY-MM-DD");
            alku.hour(0);
            alku.minute(0);
            if(nyt.isBetween(alku, loppu)) {
              validi = true;
              return;
            }
        });
        return validi;
      }
    },
    onFilterSelect(id){
      this.statusFilter = id;
    },
    onFilterSelect2(id){
      this.typeFilter = id;
    },
    onFilterSelect3(id){
      this.sourceFilter = id;
    },
    getValidity(info){
      var validity = "?";
      if(info && info.ajastusList){
        var now = Date.now();
        info.ajastusList.forEach( schedule => {
          var from = Date.parse(schedule.validityBegins);
          var to = Date.parse(schedule.validityEnds);
          if(from <= now && to >= now) validity = "valid";
          if(from > now && validity != "valid") validity = "upcoming";
          if(to < now && validity != "valid" && validity != "upcoming" ) validity = "expired";
        });
      }
      return validity;
    },
    getCreatedTooltip(info){
      var tooltip = info.tallentaja; 

      var aika = moment(info.tallennettu);
      if(aika.isValid()) {
          tooltip += " - " + aika.format("D.M.YYYY");
      }

      return tooltip;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.force-row::before {
  content: "\200B";
}

.timeInTableCell {
  margin-bottom: 0.1rem;
  svg {
    margin-right: 8px;
  }
 }

.info-status {
  width: 50px
}

</style>
